














































































































































import { Component, Vue } from "vue-property-decorator";
import { storeOutpatientWaiting } from "@/store/modules/OutpatientWaitingStore";
import OwtSvc from "@/services/OutpatientWaitingService";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import moment from "moment";
import OutpatientWaitingForm from "./OutpatientWaitingForm.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { localISODate, parseLocalDate } from "@/utils/localDate";

@Component({
  components: { OutpatientWaitingForm, VCDateTimePicker }
})
export default class OutpatientWaitingList extends Vue {
  storeModule = storeOutpatientWaiting;
  showDetail = false;
  editData: any = null;

  filterTglDari = "";
  filterTglSampai = "";
  filterPoliklinik: any = null;
  filterStatus: any = null;
  filterCapaian: any = null;
  filterSearch = "";

  statusOptions = [
    { text: "Draft", value: "draft" },
    { text: "Submitted", value: "submitted" },
    { text: "Verifikator Signed", value: "verifikator_signed" },
    { text: "Kepala Unit Signed", value: "kepala_unit_signed" },
    { text: "Published", value: "published" },
  ];

  capaianOptions = [
    { text: "Tercapai", value: "tercapai" },
    { text: "Tidak Tercapai", value: "tidak_tercapai" },
  ];

  headers = [
    { text: "No. Formulir", value: "nomor_formulir", width: "150px" },
    { text: "Tgl Sampling", value: "tanggal_sampling", width: "110px" },
    { text: "Poliklinik", value: "poliklinik", width: "150px" },
    { text: "Sample", value: "denominator_total", width: "80px" },
    { text: "Tercapai", value: "numerator_tercapai", width: "80px" },
    { text: "Capaian %", value: "capaian_persen", width: "100px" },
    { text: "Status", value: "status", width: "130px" },
    { text: "Aksi", value: "actions", sortable: false, width: "100px" },
  ];

  parseLocalDate = parseLocalDate;

  mounted() {
    this.storeModule.loadPoliklinik();
    this.loadData();
  }

  setFilterTgl(field: "filterTglDari" | "filterTglSampai", val: Date | null) {
    const next = val ? localISODate(val) : "";
    if (next === this[field]) return;
    this[field] = next;
    this.loadData();
  }

  async loadData() {
    const params: any = {};
    if (this.filterTglDari) params.tgl_dari = this.filterTglDari;
    if (this.filterTglSampai) params.tgl_sampai = this.filterTglSampai;
    if (this.filterPoliklinik) params.poliklinik_kode = this.filterPoliklinik;
    if (this.filterStatus) params.status = this.filterStatus;
    if (this.filterCapaian) params.status_capaian = this.filterCapaian;
    if (this.filterSearch) params.search = this.filterSearch;
    await this.storeModule.loadSessions(params);
  }

  formatDate(d: string) {
    return d ? moment(d).format("DD-MM-YYYY") : "-";
  }

  tambahBaru() {
    this.editData = null;
    this.showDetail = true;
  }

  lihat(item: any) {
    this.editData = item;
    this.showDetail = true;
  }

  bisaHapus(item: any): boolean {
    if (!item.is_locked) return true;
    const slots = [
      { ditandatangani: item.signed_petugas_at, penandaTanganId: item.petugas_pengisi_id },
      { ditandatangani: item.signed_verifikator_at, penandaTanganId: item.verifikator_user_id },
      { ditandatangani: item.signed_kepala_unit_at, penandaTanganId: item.kepala_unit_user_id }
    ];
    if (!slots.some(slot => !!slot.ditandatangani)) return false;
    return !alasanTtdMengunciHapus(item.creator_user_id, slots, userModule.user?.id);
  }

  async hapus(item: any) {
    if (!this.bisaHapus(item)) return;
    if (!confirm("Hapus sesi Waktu Tunggu Rawat Jalan ini?")) return;
    try {
      const resp = await OwtSvc.destroy(item.id);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil menghapus sesi");
        this.loadData();
      }
    } catch {
      // handled by ErrorAlert
    }
  }

  printPdf(id: number) {
    OwtSvc.printPdf(id);
  }

  onBack() {
    this.showDetail = false;
    this.editData = null;
    this.loadData();
  }

  onSaved() {
    this.loadData();
  }
}
